import React, { useEffect } from "react";
import "./Checkout.css";
import Subtotal from "./Subtotal";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import { useHistory, Link } from 'react-router-dom';
import { Typography, Empty, Button, Steps } from "antd";
import { ShoppingOutlined, CreditCardOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// Group basket items by ID and count quantities
function groupBasketItems(basket) {
  const grouped = {};
  basket.forEach(item => {
    if (grouped[item.id]) {
      grouped[item.id].quantity += 1;
    } else {
      grouped[item.id] = { ...item, quantity: 1 };
    }
  });
  return Object.values(grouped);
}

function Checkout() {
  const [{ basket, user }] = useStateValue();
  const history = useHistory();

  useEffect(() => {
    if (!user) {
      history.push('/login');
    }
  }, [user, history]);

  const groupedItems = groupBasketItems(basket);

  return (
    <div className="checkout">
      {/* Visual Navigation Steps */}
      <div className="checkout__steps">
        <Steps current={0}>
          <Steps.Step title="Cart" icon={<ShoppingOutlined />} />
          <Steps.Step title="Payment" icon={<CreditCardOutlined />} />
          <Steps.Step title="Complete" icon={<CheckCircleOutlined />} />
        </Steps>
      </div>

      <div className="checkout__content">
        {/* Left side: Cart Items */}
        <div className="checkout__left">
          <Title level={3} style={{ marginBottom: 4 }}>Shopping Basket</Title>
          <Text type="secondary" style={{ display: 'block', marginBottom: 20 }}>
            {user ? `Hello, ${user.email}` : 'Hello Guest'} — {basket.length} item{basket.length !== 1 ? 's' : ''} in your basket
          </Text>

          {groupedItems.length > 0 ? (
            groupedItems.map((item) => (
              <CheckoutProduct
                key={item.id}
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                rating={item.rating}
                quantity={item.quantity}
              />
            ))
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Your basket is currently empty."
              style={{ marginTop: 50 }}
            >
              <Link to="/">
                <Button type="primary">Start Shopping Now</Button>
              </Link>
            </Empty>
          )}
        </div>

        {/* Right side: Subtotal */}
        <div className="checkout__right">
          {basket.length > 0 && <Subtotal />}
        </div>
      </div>
    </div>
  );
}

export default Checkout;
